import { Direction } from '@angular/cdk/bidi';
import { PositionStrategy, ScrollStrategy } from '@angular/cdk/overlay';
import { InjectionToken, ViewContainerRef } from '@angular/core';

export type AutoFocusTarget = 'dialog' | 'first-tabbable' | 'first-heading';

export const DIALOG_DATA = new InjectionToken<unknown>('DialogData');

export class DialogConfig<D = unknown> {
  public viewContainerRef?: ViewContainerRef;
  public panelClass?: string | string[];
  public direction?: Direction;
  public data?: D | null = null;
  public hasBackdrop?: boolean = true;
  public backdropClass?: string;
  public disableClose?: boolean = false;
  public ariaLabel?: string | null = null;

  public closeOnNavigation?: boolean = true;

  public autoFocus?: AutoFocusTarget | string | boolean = 'dialog';

  public restoreFocus?: boolean = true;

  public scrollStrategy?: ScrollStrategy;
  public positionStrategy?: PositionStrategy;

  public width?: string;
  public maxWidth?: string;
  public noPadding?: boolean;

  public height?: string;
  public maxHeight?: string;
}
